import { H as i, a as r, M as t, b as a } from "./index-zjOf2lsA.js";
export {
  i as H,
  r as HighlightSegmentMiddleware,
  t as MetricCategory,
  a as configureElectronHighlight
};
//# sourceMappingURL=index.js.map
